import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-calendar-legend',
    templateUrl: './calendar-legend.component.html',
    styleUrls: ['./calendar-legend.component.less'],
})
export class CalendarLegendComponent implements OnInit {

    legends: {
        color?: string,
        label: string,
        isHalf?: boolean
    }[] = [
        {
            color: '#427cb6',
            label: 'Current Task\'s Reservation'
        },
        {
            color: '#197840',
            label: 'Other Tasks\' Reservation'
        },
        {
            color: '#FBB50D',
            label: 'Reservation With Conflict'
        },
        {
            color: '#f15a5a',
            label: 'Pending Resource Request'
        },
        {
            isHalf: true,
            label: 'Reservation is not full day'
        }
    ];
    constructor() {
    }

    ngOnInit(): void {
    }

}
